import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HeaderContent } from "./HeaderContent";
import { Seguimiento } from "./Seguimiento";
import { Eventos } from "./Eventos";

import { InfromacionCompleta } from "./InfromacionCompleta";
import { cambiarelestadodelcleinte, getBitacoraLeads, getSpecificLead } from "../../../../store/clientes/thunkClientes";
import { useNavigate } from "react-router-dom";
import { ModalEditarCliente } from "../ModalEditarCliente/ModalEditarCliente";
import Swal from "sweetalert2";
import { Cotizaciones } from "./Cotizaciones";

export const PerfilUsuario = () => {
    const dispatch = useDispatch();
    // Estado para almacenar los detalles generales del lead.
    const [leadDetails, setLeadDetails] = useState({});

    const [activeTab, setActiveTab] = useState("LineTime");
    const [BitacoraLeads, setBitacora] = useState([]);

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey); // Actualiza el estado con la pestaña seleccionada
    };

    const fetchLeadDetails = async (idLead) => {
        try {
            // Llama a la acción 'getSpecificLead' y actualiza el estado 'leadDetails'.
            const leadData = await dispatch(getSpecificLead(idLead));

            // Guarda todos los detalles del lead en el estado 'leadDetails' para su uso posterior.
            setLeadDetails(leadData);
        } catch (error) {
            console.error("Error al obtener los detalles del lead:", error); // Manejo de errores.
        }
    };

    const fetchBitacora = async (idLead) => {
        try {
            const result = await dispatch(getBitacoraLeads(idLead)); // Llama a la acción de Redux para obtener la bitácora del lead.
            setBitacora(result); // Almacena los resultados en el estado.
        } catch (error) {
            console.error("Error fetching bitacora:", error); // Maneja cualquier error.
        }
    };

    // Función para obtener el valor de un parámetro específico de la URL.
    const getQueryParam = (param) => {
        // Crea una instancia de 'URLSearchParams' con los parámetros de la URL.
        const value = new URLSearchParams(location.search).get(param);

        // Verifica si el valor es numérico. Si lo es, lo convierte a un número.
        if (value && !isNaN(value) && !isNaN(parseFloat(value))) {
            return Number(value); // Retorna el valor como número.
        }
        return value; // Si no es numérico, retorna el valor original como cadena de texto.
    };

    useEffect(() => {
        // Obtiene los parámetros 'idLead', 'idCalendar', y 'idDate' desde la URL.
        const leadId = getQueryParam("data"); // Extrae el ID del lead desde la URL.

        // Si 'leadId' es válido (mayor que 0), llama a la función para obtener los detalles del lead.
        if (leadId && leadId > 0) {
            fetchLeadDetails(leadId); // Ejecuta la solicitud para obtener los detalles del lead.
            fetchBitacora(leadId); // Ejecuta la solicitud para obtener la bitácora del lead.
        }
    }, [location.search]); // El efecto se ejecuta nuevamente si 'location.search' cambia.

    const [openModalEditarCliente, setOpenModalEditarCliente] = useState(false);

    const handleRowClickEditarCliente = () => {
        setOpenModalEditarCliente(true);
    };

    const handleCloseModalEditarCliente = () => {
        setOpenModalEditarCliente(false);
    };

    const updateClientStatus = (status) => {
        // Define el texto dinámico según el valor de `status`
        const actionText = status === 1 ? "activar" : "inactivar";
        const successText = status === 1 ? "activado" : "inactivado";

        Swal.fire({
            title: `¿Estás seguro de que deseas ${actionText} el cliente?`,
            text: `¿Deseas ${actionText} el cliente con la información proporcionada?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: `Sí, ${actionText}`,
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Mostrar preloader
                Swal.fire({
                    title: `${actionText.charAt(0).toUpperCase() + actionText.slice(1)} cliente`,
                    text: "Por favor espere...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                // Llama a la acción para cambiar el estado del cliente
                dispatch(cambiarelestadodelcleinte(leadDetails, status));

                // Mensaje de éxito y cierre del modal
                Swal.fire({
                    icon: "success",
                    title: `Cliente ${successText}`,
                    text: `El cliente ha sido ${successText} exitosamente.`,
                    confirmButtonText: "Aceptar",
                    timer: 2000, // Duración de 5 segundos
                    timerProgressBar: true, // Mostrar barra de progreso
                }).then(() => {
                    window.location.reload(); // Recargar la página después de los 5 segundos
                });
            }
        });
    };

    return (
        <>
            <HeaderContent leadInformations={leadDetails} />
            <div className="row">
                <div className="col-xxl-3 col-lg-5">
                    <div className="overflow-hidden card">
                        <div className="position-relative card-body">
                            <div className="text-center mt-3">
                                <div className="chat-avtar d-inline-flex mx-auto">
                                    <img alt="User image" loading="lazy" width="100" height="100" decoding="async" data-nimg="1" className="rounded-circle img-fluid wid-90 img-thumbnail" src="/avatar.webp" style={{ color: "transparent" }} />
                                    <i className="chat-badge bg-success me-2 mb-2"></i>
                                </div>
                                <h5 className="mb-0">{leadDetails.nombre_cliente}</h5>
                                <ul className="list-inline mx-auto my-4">
                                    <ul className="list-inline mx-auto my-4">
                                        <li className="list-inline-item">
                                            <button className="btn btn-sm btn-dark" onClick={() => handleRowClickEditarCliente()}>
                                                <i className="ti ti-edit-circle f-24"></i> Editar Perfil
                                            </button>
                                        </li>
                                        <li className="list-inline-item">
                                            {leadDetails.esatdo_cliente === 1 ? (
                                                <button className="btn btn-sm btn-danger" onClick={() => updateClientStatus(0)}>
                                                    <i className="ti ti-x f-24"></i> Inactivar cliente
                                                </button>
                                            ) : (
                                                <button className="btn btn-sm btn-success" onClick={() => updateClientStatus(1)}>
                                                    <i className="ti ti-check f-24"></i> Activar cliente
                                                </button>
                                            )}
                                        </li>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                        <div className="flex-column list-group list-group-flush account-pills mb-0 nav nav-pills" id="user-set-tab" aria-orientation="vertical" role="tablist">
                            <a onClick={() => handleTabClick("LineTime")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "LineTime" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-user-circle m-r-10"></i>Bitácora de Seguimiento
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Eventos")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Eventos" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-calendar m-r-10"></i> Lista de eventos
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Cotizaciones")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Cotizaciones" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-notebook m-r-10"></i> Cotizaciones
                                </span>
                            </a>
                            <a onClick={() => handleTabClick("Informacion")} role="tab" className={`list-group-item list-group-item-action nav-link ${activeTab === "Informacion" ? "active" : ""}`}>
                                <span className="f-w-500">
                                    <i className="ph-duotone ph-user-circle m-r-10"></i> Informacion Completada
                                </span>
                            </a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Informacion Basica</h5>
                        </div>
                        <div className="position-relative card-body">
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Correo cliente</p>
                                <p className="mb-0">{leadDetails.correo_cleinte}</p>
                            </div>
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Telefono Cliente</p>
                                <p className="mb-0">{leadDetails.telefono_cliente}</p>
                            </div>
                            <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                                <p className="mb-0 text-muted me-1">Nombre de la empresa</p>
                                <p className="mb-0">{leadDetails.nombre_empresa}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-9 col-lg-7">
                    <div className="tab-content" id="user-set-tabContent">
                        {activeTab === "LineTime" && (
                            <div id="react-aria8348725315-:r6:-tabpane-LineTime" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-LineTime" className="fade fade tab-pane active show">
                                <Seguimiento BitacoraLeads={BitacoraLeads} />
                            </div>
                        )}
                        {activeTab === "Eventos" && (
                            <div id="react-aria8348725315-:r6:-tabpane-Eventos" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-Eventos" className="fade fade tab-pane active show">
                                <Eventos leadDetails={leadDetails} />
                            </div>
                        )}
                        {activeTab === "Cotizaciones" && (
                            <div id="react-aria8348725315-:r6:-tabpane-Cotizaciones" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-Cotizaciones" className="fade fade tab-pane active show">
                                <Cotizaciones leadDetails={leadDetails} />
                            </div>
                        )}
                        {activeTab === "Informacion" && (
                            <div id="react-aria8348725315-:r6:-tabpane-Informacion" role="tabpanel" aria-labelledby="react-aria8348725315-:r6:-tab-Informacion" className="fade fade tab-pane active show">
                                <InfromacionCompleta leadDetails={leadDetails} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {openModalEditarCliente && <ModalEditarCliente open={true} onClose={handleCloseModalEditarCliente} clienteid={leadDetails} />}
        </>
    );
};
